import React from 'react'

import { Button } from '../../Button'
import { ArrowRight } from '../../icons'
import { ENQUIRY_PATH, UNVEILING_PATH } from '../../paths'
import { LOADING_TEXT, UNAVAILABLE_TEXT } from '../twinContent'

// Covers the frame until the scene has built - and stays up with a way out if it never will.
export function TwinLoading({ visible, failed }: { visible: boolean; failed?: boolean }) {
  if (!visible) return null

  if (!failed) return <div id="loading">{LOADING_TEXT}</div>

  return (
    <div id="loading">
      <div className="flex flex-col items-center gap-6 px-6 text-center">
        <p className="max-w-[34ch]">{UNAVAILABLE_TEXT}</p>
        <div className="flex flex-wrap justify-center gap-3">
          <Button
            href={ENQUIRY_PATH}
            variant="primary"
            trailing={<ArrowRight className="size-3" />}
          >
            Register your interest
          </Button>
          <Button href={UNVEILING_PATH}>Back to The Unveiling</Button>
        </div>
      </div>
    </div>
  )
}
